import React from "react";
import { Box, Typography, Button } from "@mui/material";

import CustomDialog from "../../components-new/common/CustomDialog";

const UpdateStepsDialog = ({
  open,
  onClose,
  selectedItems = [],
  isUpdating = false,
  onUpdate,
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      width="400px"
      title="Update Selected Steps"
      content={
        <Box width="100%" mt={1}>
          <Typography variant="body2" color="text.secondary" mb={2.5}>
            You are about to update <strong>{selectedItems.length}</strong> test step
            {selectedItems.length > 1 ? "s" : ""}. Do you want to proceed?
          </Typography>
        </Box>
      }
      actions={
        <Box display="flex" justifyContent="flex-end" mt={1} width="100%" gap={1}>
          <Button
            onClick={onClose}
            sx={{ color: "#8089A8", textTransform: "none", borderRadius: 0 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={isUpdating}
            onClick={onUpdate}
            sx={{
              textTransform: "none",
              borderRadius: 0,
              boxShadow: "none",
              backgroundColor: "#547de8",
              "&:hover": { backgroundColor: "#3b63d4", boxShadow: "none" },
            }}
          >
            Update
          </Button>
        </Box>
      }
    />
  );
};

export default UpdateStepsDialog;
